// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aaltra--layout.has-navigation .navigation+.empty-page{margin-top:32px;padding-top:0;position:relative}", ""]);
// Exports
module.exports = exports;
